module.exports = __webpack_public_path__ + "static/img/4.8a889da3.jpg";